<template>
  <!-- menuL2-->
  <div class="">
    <!--删除列表时使用的是rowKey的id-->
    <x-tabula
      ref="table"
      rowKey="categoryId"
      :dataSource="dataSource"
      :searchList="searchList"
      :columns="columns"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="false"
    >
    </x-tabula>
  </div>
</template>

<script>
export default {
  name: 'commissionSetLevel2',
  data () {
    return {
      visible: false,
      rowData: {},
      searchList: [
        {
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '类目名称',
          props: ['categoryName']
        }
      ],
      rowOptList: [
        {
          text: '三级目录',
          handle: row => this.toL3(row),
          permi: ['community:category:category3List']
        }
      ],
      columns: [
        {
          title: '类目名称',
          dataIndex: 'categoryName',
          align: '',
          width: '80%'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: '',
          scopedSlots: { customRender: 'action' }
        }
      ],
      dataSource: [],
      searchParams: {
        categoryName: undefined
      },
      listApi: {
        url: '',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      }
    };
  },
  created () {
    if (this.$route.query.categoryId) {
      let categoryId = this.$route.query.categoryId;
      this.listApi.url = '/local/category/category2/list/' + categoryId;
    }
  },
  methods: {
    toL3 (row) {
      this.$router.push({
        name: 'commissionSetLevel3',
        query: {
          categoryId: row.categoryId
        }
      });
    },
    showbigimg (img, title) {
      this.$refs.bigImg.show(img, title);
    },
    /** 弹窗详情 */
    modalDetail (row) {
      this.visible = true;
      this.rowData = row;
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
